<template>
    <base-modal
        class="upsell-modal"
        @close="checkForDialogOnOutsideClick"
    >
        <header class="upsell-modal__header">
            <div class="upsell-modal__title-bar">
                <h1 class="upsell-modal__title">Upgrade Organization</h1>

                <button
                    class="btn-close"
                    @click="closeUpsellPage"
                >
                    <img
                        src="/images/close.svg"
                        alt="close"
                    />
                </button>
            </div>

            <p class="upsell-modal__subheading">
                for greater access to Mission Command. Contact our team to switch plans, add seats, or for more
                information.
            </p>
        </header>

        <div class="upsell-modal__body upsell-text">
            <div class="upsell-fields">
                <div class="upsell-row upsell-description"></div>

                <div class="upsell-row upsell-info">
                    <div class="upsell-row__cell">
                        <div class="upsell-info__section">
                            <span class="upsell-info__field-text">Seats</span>
                            <info-tooltip>
                                The max number of users with permission to view the backhaul map
                            </info-tooltip>
                        </div>

                        <div class="upsell-info__section">
                            <span class="upsell-info__field-text">Map Nodes</span>

                            <info-tooltip>
                                The max number of field users simultaneously visible on backhaul map
                            </info-tooltip>
                        </div>
                    </div>
                </div>

                <div class="upsell-row upsell-features">
                    <div class="upsell-row__cell">Features</div>
                </div>
            </div>

            <div
                v-for="(plan, i) in plans"
                :key="i"
                class="upsell-plan"
            >
                <div class="upsell-row upsell-description">
                    <div class="upsell-row__cell">
                        <div class="upsell-description__data">{{ plan.name }}</div>

                        <div
                            v-if="plan.isPaid"
                            class="upsell-description__data"
                        >
                            <a
                                :href="`mailto:prosales.gotenna.com?subject=goTenna Mission Command Upgrade`"
                                class="btn-sale"
                            >
                                Contact Sales
                            </a>
                        </div>
                    </div>
                </div>

                <div class="upsell-row upsell-info">
                    <div class="upsell-row__cell">
                        <div class="upsell-info__section">{{ plan.seats }}</div>

                        <div class="upsell-info__section">{{ plan.mapNodes }}</div>
                    </div>
                </div>

                <div class="upsell-row upsell-features">
                    <div class="upsell-row__cell">
                        <div
                            v-for="(feature, featureIndex) in plan.features"
                            :key="featureIndex"
                            class="upsell-features__section"
                        >
                            {{ feature }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </base-modal>
</template>

<script>
import canClose from '@/mixins/canClose'
import BaseModal from '@/components/Modals/BaseModal.vue'
import InfoTooltip from '@/components/InfoTooltip.vue'

export default {
    components: {
        BaseModal,
        InfoTooltip,
    },
    mixins: [canClose],

    data() {
        return {
            plans: [
                {
                    name: 'Free Plan',
                    isPaid: false,
                    seats: '1',
                    mapNodes: '5',
                    features: [
                        'Manage users & groups',
                        'Manage frequencies',
                        'Distribute Mission Plans',
                        'Manage PLI on map',
                        'Staleout alerts',
                    ],
                },
                {
                    name: 'Advanced Plan',
                    isPaid: true,
                    seats: 'up to 100',
                    mapNodes: 'up to 5000',
                    features: ['Free Plan, plus:', 'Chat with mobile users', 'Upload custom maps '],
                },
            ],
        }
    },

    methods: {
        checkForDialogOnOutsideClick(e) {
            // The paywall dialog's buttons trigger v-click-outside, so a
            // click coming from anywhere inside that dialog must not close
            // the upsell page. Matched by ancestry because the click lands
            // on the button, which does not carry the dialog's own class.
            if (!this.hasBlockingClass(e)) {
                this.closeUpsellPage()
            }
        },

        closeUpsellPage() {
            this.$store.dispatch('mission/setUpsellPageDisplay', false)
        },
    },
}
</script>

<style scoped>
.upsell-modal :deep(.modal) {
    width: 840px;
    height: 503px;
    padding: 40px;
    display: flex;
    flex-direction: column;
}

.upsell-modal__header {
    margin-bottom: 20px;
}

.upsell-modal__title-bar {
    display: flex;
    justify-content: space-between;
}

.upsell-modal__title {
    font-size: 1.125rem;
}

.upsell-modal__subheading {
    font-size: 0.875rem;
    margin-top: 8px;
    font-weight: 300px;
}

.upsell-modal__body {
    display: flex;
    flex: 1;
}

.upsell-plan,
.upsell-fields {
    display: flex;
    flex-direction: column;
    border-right: 0.5px solid #8f999d;
    font-size: 0.875rem;
}

.upsell-fields {
    width: 160px;
}

.upsell-plan {
    flex: 1;
}

.upsell-plan:last-child {
    border-right: 0;
}

.upsell-row {
    border-top: 0.5px solid #8f999d;
}

.upsell-description {
    height: 105px;
}

.upsell-description__data {
    font-size: 18px;
    margin-bottom: 15px;
}

.upsell-info {
    height: 93px;
}

.upsell-info__section {
    margin-bottom: 15px;
}

.upsell-info__field-text {
    margin-right: 5px;
}

.upsell-features {
    flex: 1;
}

.upsell-features__section {
    margin-bottom: 8px;
}

.upsell-row__cell {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.upsell-plan .upsell-row__cell {
    margin-left: 20px;
}

.btn-sale {
    height: 25px;
    width: 95px;
    line-height: 26px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    border-radius: 8px;
    color: #ffffff;
    cursor: pointer;
    font-size: 0.75rem;
    background-color: #2196f3;
}

.btn-close {
    cursor: pointer;
    background: none;
    border: none;
}
</style>
